export const PROJECTS_SET_SELECTED_PROJECT = 'PROJECTS_SET_SELECTED_PROJECT';
